import React, { Component } from 'react';
import './dropDownMenu.css';
import Menu from './../images/Menu.png';
import Close from './../images/cancel.png';
import { withRouter } from 'react-router';


class DropDownMenu extends Component<any, any>
{

    constructor(props: any){
        super(props);
        this.state = {
            isDrawerOpen: false,
        }
    }

    toggleDrawerOpen = () => {
        this.setState({isDrawerOpen: !this.state.isDrawerOpen});
    }

    render() {
        
        let mainDivClass = "HideNavigationMenuMainDiv";
        let menuIconDisplay = "";
        let closeIconDisplay = "d-none";
        let menuItemDisplay = "d-none";
        if(this.state.isDrawerOpen){
            mainDivClass = "DisplayNavigationMenuMainDiv";
            menuIconDisplay = "d-none";
            closeIconDisplay = "";
            menuItemDisplay = "";
        }

        let comp = this;

        return(
            
            <div className="row MainDropDiv">
                <div className="col HeaderDivTitle pt-2 pointerMouse" onClick={() => comp.props.history.push("/")}>
                    <u>MANIDEEP <br/> MADABHUSHANI</u>
                </div>
                
                <div className="col pt-2 pr-0">
                    <div className={mainDivClass + " d-flex flex-column justify-content-around"}>
                    
                        <img src={Menu} className={"menuButton ml-auto " + menuIconDisplay} alt="Menu" onClick={this.toggleDrawerOpen}/>

                        <img src={Close} className={"menuButton ml-auto " + closeIconDisplay} alt="Menu" onClick={this.toggleDrawerOpen}/>
                    
                        <div className={"menuItem " + menuItemDisplay } onClick={() => {comp.toggleDrawerOpen(); comp.props.history.push("/about");}}> <span className="menuItemText pl-5">ABOUT</span></div>                
                        <div className={"menuItem " + menuItemDisplay } onClick={() => {comp.toggleDrawerOpen(); comp.props.history.push("/work-exp");}}> <span className="menuItemText pl-4">WORK</span></div>        
                        <div className={"menuItem " + menuItemDisplay } onClick={() => {comp.toggleDrawerOpen(); comp.props.history.push("/recognitions");}}> <span className="menuItemText pl-4">RECOGNITIONS</span></div>        
                        <div className={"menuItem " + menuItemDisplay } onClick={() => {comp.toggleDrawerOpen(); comp.props.history.push("/social");}}> <span className="menuItemText pl-5">SOCIAL</span></div>
                
                    </div>
                </div>
            </div>
        
        );
    }
}

export default withRouter(DropDownMenu);